export default "__VITE_ASSET__a8311c95__"